(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adaptive-image-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('adaptive-slideshow')) {
    class AdaptiveSlideshow extends HTMLElement {
      constructor() {
        super();
        this.index = 0;
        this._timer = null;
      }

      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        if (!this.slides.length) return;

        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.count = this.slides.length;
        this.adapt = this.dataset.height === 'adapt';
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.index - 1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.index + 1));
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.go(parseInt(dot.dataset.dot, 10)));
        });

        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
        });

        this._bindSwipe();
        this.set(0);

        this.autoplay = this.dataset.autoplay === 'true' && this.count > 1 && !this.reduceMotion;
        this.speed = (parseFloat(this.dataset.autoplaySpeed) || 5) * 1000;
        if (this.autoplay) {
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.start());
          document.addEventListener('visibilitychange', () => {
            document.hidden ? this.stop() : this.start();
          });
          this.start();
        }
      }

      disconnectedCallback() {
        this.stop();
      }

      set(i) {
        this.index = i;
        this.style.setProperty('--ab-active', i);

        this.slides.forEach((slide, idx) => {
          const active = idx === i;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        this.dots.forEach((dot, idx) => {
          const active = idx === i;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        if (this.adapt) {
          const slide = this.slides[i];
          if (slide.dataset.arDesktop) this.style.setProperty('--active-ar-desktop', slide.dataset.arDesktop);
          if (slide.dataset.arMobile) this.style.setProperty('--active-ar-mobile', slide.dataset.arMobile);
        }
      }

      go(i) {
        const next = (i + this.count) % this.count;
        this.set(next);
        if (this.autoplay) { this.stop(); this.start(); }
      }

      start() {
        if (!this.autoplay) return;
        this.stop();
        this._timer = setInterval(() => this.go(this.index + 1), this.speed);
      }

      stop() {
        if (this._timer) { clearInterval(this._timer); this._timer = null; }
      }

      _bindSwipe() {
        let startX = null;
        this.addEventListener('pointerdown', (e) => { startX = e.clientX; });
        this.addEventListener('pointerup', (e) => {
          if (startX === null) return;
          const dx = e.clientX - startX;
          startX = null;
          if (Math.abs(dx) > 40) { dx < 0 ? this.go(this.index + 1) : this.go(this.index - 1); }
        });
        this.addEventListener('pointercancel', () => { startX = null; });
      }
    }

    customElements.define('adaptive-slideshow', AdaptiveSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rawat-product-hero"] && !Shopify.designMode) return;
  try {
    
  /**
   * Rawat Product Page Logic
   * Handles: variant switching, price update, image gallery, qty stepper, buy now, sticky bar
   */
  (function() {
    const sections = document.querySelectorAll('.rawat-product');
    sections.forEach(initSection);

    function initSection(section) {
      if (!section) return;

      const moneyFormat = window.Shopify && window.Shopify.money_format ? window.Shopify.money_format : '₹{{amount}}';

      function formatMoney(cents) {
        const amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
        const withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return moneyFormat.replace('{{amount}}', withCommas).replace('{{amount_no_decimals}}', amount.split('.')[0]);
      }

      // ─── Variant Selection ───
      const variantCards = section.querySelectorAll('[data-rp-variant-id]');
      const variantInput = section.querySelector('[data-rp-variant-input]');
      const priceEl = section.querySelector('[data-rp-price]');
      const mrpEl = section.querySelector('[data-rp-mrp]');
      const priceBlock = section.querySelector('[data-rp-price-block]');
      const stickyPriceEl = section.querySelector('[data-rp-sticky-price]');
      const addToCartBtn = section.querySelector('[data-rp-add-to-cart]');
      const stickyAddBtn = section.querySelector('[data-rp-sticky-add]');
      const buyNowBtn = section.querySelector('[data-rp-buy-now]');
      const addText = section.querySelector('[data-rp-add-text]');

      // Gallery elements (declared early so variant handler can switch images)
      const galleryMainImages = section.querySelectorAll('[data-rp-image-index]');
      const galleryThumbs = section.querySelectorAll('[data-rp-thumb]');

      // Helper: switch the main gallery image + active thumbnail to a given index
      function switchGalleryImage(idx) {
        idx = String(idx);
        var matched = false;
        galleryMainImages.forEach(function(img) {
          var isMatch = img.getAttribute('data-rp-image-index') === idx;
          img.classList.toggle('rawat-product__main-image-item--active', isMatch);
          if (isMatch) matched = true;
        });
        if (!matched) return; // no image at that index, leave gallery as-is
        galleryThumbs.forEach(function(t) {
          t.classList.toggle('rawat-product__thumb--active', t.getAttribute('data-rp-thumb') === idx);
        });
        // Scroll the active thumb into view if thumbs are scrollable
        var activeThumb = section.querySelector('[data-rp-thumb="' + idx + '"]');
        if (activeThumb && activeThumb.scrollIntoView) {
          activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      }

      variantCards.forEach(function(card) {
        card.addEventListener('click', function() {
          if (card.disabled) return;

          variantCards.forEach(c => c.classList.remove('rawat-product__variant-card--active'));
          card.classList.add('rawat-product__variant-card--active');

          const variantId = card.getAttribute('data-rp-variant-id');
          const priceCents = parseInt(card.getAttribute('data-rp-variant-price'), 10);
          const mrpCents = parseInt(card.getAttribute('data-rp-variant-mrp'), 10);
          const available = card.getAttribute('data-rp-variant-available') === 'true';

          if (variantInput) variantInput.value = variantId;

          if (priceEl) priceEl.textContent = formatMoney(priceCents);
          if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(priceCents);

          if (priceBlock) {
            const existingMrp = priceBlock.querySelector('[data-rp-mrp]');
            if (mrpCents > priceCents) {
              if (existingMrp) {
                existingMrp.textContent = formatMoney(mrpCents);
              } else {
                const span = document.createElement('span');
                span.className = 'rawat-product__price-mrp';
                span.setAttribute('data-rp-mrp', '');
                span.textContent = formatMoney(mrpCents);
                priceEl.insertAdjacentElement('afterend', span);
              }
            } else if (existingMrp) {
              existingMrp.remove();
            }
          }

          // Update URL
          if (window.history && window.history.replaceState) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variantId);
            window.history.replaceState({}, '', url.toString());
          }

          // Toggle availability on buttons
          [addToCartBtn, buyNowBtn, stickyAddBtn].forEach(btn => {
            if (!btn) return;
            btn.disabled = !available;
          });
          if (addText) addText.textContent = available ? (addText.getAttribute('data-default') || addText.textContent || 'Add to Cart') : 'Sold Out';
          if (stickyAddBtn) stickyAddBtn.textContent = available ? 'Add to Cart' : 'Sold Out';

          // ─── Switch gallery image to this variant's assigned image ───
          const mediaIdx = card.getAttribute('data-rp-variant-media');
          if (mediaIdx !== null && mediaIdx !== '') {
            switchGalleryImage(mediaIdx);
          }
        });
      });

      // ─── Image Gallery (thumbnail clicks) ───
      galleryThumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          const idx = thumb.getAttribute('data-rp-thumb');
          galleryMainImages.forEach(function(img) {
            img.classList.toggle('rawat-product__main-image-item--active', img.getAttribute('data-rp-image-index') === idx);
          });
          galleryThumbs.forEach(t => t.classList.remove('rawat-product__thumb--active'));
          thumb.classList.add('rawat-product__thumb--active');
        });
      });

      // Thumb scroll arrows
      const thumbsTrack = section.querySelector('[data-rp-thumbs-track]');
      const thumbPrev = section.querySelector('[data-rp-thumb-prev]');
      const thumbNext = section.querySelector('[data-rp-thumb-next]');
      if (thumbsTrack && thumbPrev && thumbNext) {
        thumbPrev.addEventListener('click', () => thumbsTrack.scrollBy({ left: -200, behavior: 'smooth' }));
        thumbNext.addEventListener('click', () => thumbsTrack.scrollBy({ left: 200, behavior: 'smooth' }));
      }

      // ─── Quantity Stepper ───
      const qtyInput = section.querySelector('[data-rp-qty-input]');
      const qtyButtons = section.querySelectorAll('[data-rp-qty]');
      qtyButtons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          if (!qtyInput) return;
          const delta = parseInt(btn.getAttribute('data-rp-qty'), 10);
          const current = parseInt(qtyInput.value, 10) || 1;
          const newVal = Math.max(1, current + delta);
          qtyInput.value = newVal;
        });
      });

      // ─── Buy Now ───
      if (buyNowBtn) {
        buyNowBtn.addEventListener('click', function() {
          const qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
          const variantId = variantInput ? variantInput.value : (section.querySelector('input[name="id"]') ? section.querySelector('input[name="id"]').value : null);
          if (!variantId) return;
          window.location.href = '/cart/' + variantId + ':' + qty;
        });
      }

      // ─── Sticky Bar Add to Cart (triggers form submit) ───
      if (stickyAddBtn) {
        stickyAddBtn.addEventListener('click', function() {
          if (addToCartBtn) addToCartBtn.click();
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rawat-testimonials"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initTestimonialsCarousel(section) {
    const grid = section.querySelector('.rawat-testimonials__grid');
    const nav = section.querySelector('[data-rt-nav]');
    if (!grid || !nav) return;
    const dotsContainer = section.querySelector('[data-rt-dots]');
    const prevBtn = section.querySelector('[data-rt-prev]');
    const nextBtn = section.querySelector('[data-rt-next]');
    const cards = grid.querySelectorAll('.rawat-testimonials__card');
    if (cards.length === 0) return;

    // Autoplay settings (from the section's data attributes)
    const autoplay = section.dataset.rtAutoplay === 'true';
    const interval = parseInt(section.dataset.rtInterval, 10) || 4000;
    let timer = null;

    // Build dot indicators (one per card)
    dotsContainer.innerHTML = '';
    cards.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'rawat-testimonials__dot' + (i === 0 ? ' rawat-testimonials__dot--active' : '');
      dot.setAttribute('aria-label', 'Go to review ' + (i + 1));
      dot.addEventListener('click', function() { scrollToCard(i); restartAutoplay(); });
      dotsContainer.appendChild(dot);
    });
    function scrollToCard(index) {
      const card = cards[index];
      if (!card) return;
      grid.scrollTo({
        left: card.offsetLeft - grid.offsetLeft - parseFloat(getComputedStyle(grid).paddingLeft || 0),
        behavior: 'smooth'
      });
    }
    function getCurrentIndex() {
      const scrollLeft = grid.scrollLeft;
      const padLeft = parseFloat(getComputedStyle(grid).paddingLeft || 0);
      let closest = 0;
      let closestDist = Infinity;
      cards.forEach(function(card, i) {
        const cardLeft = card.offsetLeft - grid.offsetLeft - padLeft;
        const dist = Math.abs(cardLeft - scrollLeft);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      return closest;
    }
    function updateUI() {
      const idx = getCurrentIndex();
      const dots = dotsContainer.querySelectorAll('.rawat-testimonials__dot');
      dots.forEach(function(d, i) {
        d.classList.toggle('rawat-testimonials__dot--active', i === idx);
      });
      // When autoplay is on it loops, so don't grey-out the arrows
      if (!autoplay) {
        if (prevBtn) prevBtn.disabled = idx === 0;
        if (nextBtn) nextBtn.disabled = idx === cards.length - 1;
      }
    }
    // How many whole cards fit on screen (so we loop at the right spot)
    function howManyVisible() {
      const gap = parseFloat(getComputedStyle(grid).gap || 0);
      const cardWidth = cards[0].offsetWidth + gap;
      return Math.max(1, Math.round(grid.clientWidth / cardWidth));
    }
    function advance() {
      const idx = getCurrentIndex();
      const maxIdx = Math.max(0, cards.length - howManyVisible());
      const next = idx >= maxIdx ? 0 : idx + 1;
      scrollToCard(next);
    }
    function startAutoplay() {
      if (!autoplay || cards.length <= 1) return;
      stopAutoplay();
      timer = setInterval(advance, interval);
    }
    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        scrollToCard(Math.max(0, getCurrentIndex() - 1));
        restartAutoplay();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        scrollToCard(Math.min(cards.length - 1, getCurrentIndex() + 1));
        restartAutoplay();
      });
    }
    // Pause when the visitor hovers or swipes; resume after
    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);
    grid.addEventListener('touchstart', stopAutoplay, { passive: true });
    grid.addEventListener('touchend', function() {
      setTimeout(startAutoplay, 1500);
    }, { passive: true });
    // Only run while the section is actually on screen
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) { startAutoplay(); }
          else { stopAutoplay(); }
        });
      }, { threshold: 0.2 });
      io.observe(section);
    } else {
      startAutoplay();
    }
    // Keep dots in sync while scrolling
    let scrollTimeout;
    grid.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateUI, 80);
    });
    updateUI();
    // Don't auto-rotate for visitors who prefer reduced motion
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      stopAutoplay();
    }
  }
  document.querySelectorAll('.rawat-testimonials').forEach(initTestimonialsCarousel);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-choose-rawat"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.currentScript ? document.currentScript.closest('.why-choose-rawat') : null;
    if (!section) return;

    const triggers = section.querySelectorAll('.scroll-trigger');
    if (!triggers.length || !('IntersectionObserver' in window)) {
      triggers.forEach(el => el.classList.add('scroll-trigger--in-view'));
      return;
    }

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('scroll-trigger--in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });

    triggers.forEach(function(el) { observer.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();
})();
